export default {
  groups: [{
      styleClasses: 'col-sm-6 row',
      fields: [{
          type: 'input',
          inputType: 'text',
          label: 'Name',
          model: 'name',
          maxlength: 50,
          required: true,
          placeholder: "Name",
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'input',
          inputType: 'text',
          label: 'Type',
          model: 'type',
          required: true,
          placeholder: "type",
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'input',
          inputType: 'number',
          label: 'Order',
          model: 'order',
          required: true,
          placeholder: "order",
          styleClasses: 'col-sm-6'
        },
        {
          type: "select",
          label: "Status",
          model: "status",
          values: [
            "active",
            "inactive"
          ],
          styleClasses: 'col-sm-6'
        }
      ]
    },
    {
      styleClasses: 'col-sm-6 row',
      fields: [{
        type: "cropper",
        model: 'image',
        package: 'croppie',
        label: 'Photo',
        required: true,
        options: {
          aspect: 1,
          width: 400,
          height: 225,
          resizable: false,
        },
        styleClasses: 'col-sm-12'
      }, ]
    }
  ]
}